import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Mutator to update change notification status
 */
export default mutatorAction('updateChangeNotificationStatusInInitialState', function updateChangeNotificationStatusInInitialState(folderId, status) {
    var store = getStore();
    store.initialState[folderId] = status;
});
//# sourceMappingURL=updateChangeNotificationStatusInInitialState.js.map